import API from '@app/api';
import Notification from '@app/action/notification';
import Pending from '@app/action/pending';

import ActionHelper from '@module/redux-actions';
import { HttpResponseCodes } from '@module/http/axios/response';

export const actions = ActionHelper.types([
  'GET_INVITATION',
  'GET_INVITATIONS',

  'INVITE_TO_TEAM_SUCCESS',
  'DELETE_INVITATION_SUCCESS',
  'UPDATE_INVITATION_SUCCESS',
]);

export default ActionHelper.generate({
  createInvitation(email, role, accountId) {
    const pendingId = 'inviteToTeam';

    return async (dispatch) => {
      dispatch(Pending.setPending(pendingId));

      try {
        const response = await API.Invitation.createInvitation({
          invitee_email: email,
          role,
          account_id: accountId,
        });

        dispatch({
          type: actions.INVITE_TO_TEAM_SUCCESS,
          invitee: response.body,
        });

        dispatch(
          Notification.setNotification('notification', 'invited_to_team', {
            email: email,
          })
        );
      } catch (error) {
        if (
          error.status === HttpResponseCodes.UNPROCESSABLE_ENTITY &&
          error.body.message &&
          error.body.message.invitee_email
        ) {
          dispatch(
            Notification.setNotification(
              'error',
              'duplicate_invitation_to_team_error'
            )
          );
        } else {
          dispatch(
            Notification.setNotification('error', 'invite_to_team_error')
          );
        }
      }

      dispatch(Pending.resetPending(pendingId));
    };
  },

  getInvitations(accountId) {
    const pendingId = 'getTeamInvitations';

    return async (dispatch) => {
      dispatch(Pending.setPending(pendingId));

      try {
        const response = await API.Invitation.getInvitations({
          account_id: accountId,
        });

        dispatch({
          type: actions.GET_INVITATIONS,
          invitations: response.body,
        });
      } catch (error) {
        dispatch(
          Notification.setNotification(
            'error',
            'retrieve_team_invitations_exception'
          )
        );
      }

      dispatch(Pending.resetPending(pendingId));
    };
  },

  getInvitation(token) {
    const pendingId = 'getInvitation';

    return async (dispatch) => {
      dispatch(Pending.setPending(pendingId));

      try {
        const response = await API.Invitation.getInvitation(null, {
          pathExtValues: {
            token,
          },
        });

        dispatch({
          type: actions.GET_INVITATION,
          invitation: response.body,
        });
      } catch (error) {
        dispatch(
          Notification.setNotification(
            'error',
            'retrieve_team_invitation_exception'
          )
        );
      }

      dispatch(Pending.resetPending(pendingId));
    };
  },

  updateInvitation(token, invitation) {
    const pendingId = 'updateInvitation';

    return async (dispatch) => {
      dispatch(Pending.setPending(pendingId));

      try {
        await API.Invitation.updateInvitation(
          { ...invitation },
          {
            pathExtValues: {
              token,
            },
          }
        );

        dispatch({
          type: actions.UPDATE_INVITATION_SUCCESS,
        });
        const url = new URL('/account', location.origin);
        location.assign(url.href);
      } catch (error) {
        dispatch(Notification.setNotification('error', 'something_went_wrong'));
      }

      dispatch(Pending.resetPending(pendingId));
    };
  },

  deleteInvitation(invitation) {
    const pendingId = 'deleteInvitation';

    return async (dispatch) => {
      dispatch(Pending.setPending(pendingId));

      try {
        await API.Invitation.deleteInvitation(null, {
          pathExtValues: {
            invitationId: invitation.id,
          },
        });

        dispatch({
          type: actions.DELETE_INVITATION_SUCCESS,
          invitation,
        });

        dispatch(
          Notification.setNotification(
            'notification',
            'cancelled_team_invitation',
            { email: invitation.invitee_email }
          )
        );
      } catch (error) {
        dispatch(Notification.setNotification('error', 'something_went_wrong'));
      }

      dispatch(Pending.resetPending(pendingId));
    };
  },
});
